import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetBankCardActivityField extends Http {
  [x: string]: any
  // 高危银行卡
  public async getBankCardActivityField(data: NLoginApi.BankCardActivityFieldRequestData) {
    return await super.request<NLoginApi.BankCardActivityFieldResponse>({
      url: '/crossbowSystem/bankActivityTrend',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getBankNames(data: NLoginApi.ActivityBankNamesRequestData) {
    return await super.request<NLoginApi.ActivityBankNamesResponse>({
      url: '/crossbowSystem/getActivityBankNames',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }

  public async getProvince(data: NLoginApi.ProvinceRequestData) {
    return await super.request<NLoginApi.ProvinceResponse>({
      url: '/org/province',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async setBankActivityPreferences(data: NLoginApi.BankActivityPreferencesRequestData) {
    return await super.request<NLoginApi.BankActivityPreferencesResponse>({
      url: '/crossbowSystem/setBankActivityPreferences',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  /**
   * 获取银行活动地图趋势数据
   * @param data 包含银行名称、地区和时间范围的请求参数
   * @returns 地区活跃度数据
   */
  public async getBankActivityMapTrend(data: NLoginApi.BankActivityMapTrendRequestData) {
    return await super.request<NLoginApi.BankActivityMapTrendResponse>({
      url: '/crossbowSystem/bankActivityMapTrend',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default GetBankCardActivityField
